export default {"src":"/_next/static/media/solid-star.6da0e975.svg","height":24,"width":26};